/*
 * **** ONLY ADD THE CONFIGURATION MARKET AND PROPERTY IF NOT UTILIZING THE DEFAULT VALUES ****
 * Display Order
 * String Options are: 'city', 'state', 'zip', 'county', 'country'
 * Fields not found in the nested array will NOT be displayed.
 * Default: [['city', 'state', 'zip']] - This option will display: Provo, UT 84601 (county and country will not be displayed.)
 * Other examples:
 * [['county', 'zip', 'country], ['state', 'city']] will display:
 *      Utah County, 84601 US
 *      Utah Provo
 * [['city', 'country', 'zip']]
 *      Singapore, SG 600011
 * At this time, the comma punctuation is always after the first field.  Will be re-worked once the need arise for a different placement
 */
export const SHIPPING_INFO_CONFIG = {
    JP: {
        displayOrder: [
            ['zip', 'state'],
            ['city', 'county'],
            ['address1']
        ]
    },
    PH: {
        displayOrder: [
            ['address1'],
            ['address2'],
            ['city', 'country', 'zip']
        ]
    },
    SG: {
        displayOrder: [
            ['address1'],
            ['address2'],
            ['city', 'country', 'zip']
        ]
    }
};
